// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Ts-z","tooltipWrapper":"Us-z","icon":"Vs-z","tooltip":"Ws-z","content":"Xs-z"};